export default __webpack_public_path__ + "static/media/edit.d905ebce.svg";